import { FamilyDetail } from './FamilyDetail';
export default FamilyDetail;